/**
 * Board, list and card values shared by backend and frontend. Runtime values the
 * frontend bundles, so this file imports nothing.
 */

/**
 * Where an ordered row lands among its siblings. Omit the whole placement to append
 * after the last sibling. `prevId` is the sibling that sits immediately above the row
 * after the write, `nextId` the one immediately below; null on either side means the
 * row lands at that end.
 */
export interface IRankPlacement {
   prevId: string | null;
   nextId: string | null;
}

/** Color a new folder or board starts with: deep-purple-400, the default board swatch. */
export const DEFAULT_BOARD_COLOR = '#7e57c2';
